module.exports = __webpack_public_path__ + "static/media/downPage.b991751d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/downPage.svg
// module id = 210
// module chunks = 0